import {
  Component,
  DestroyRef,
  HostListener,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import { Color, NgxChartsModule, ScaleType } from '@swimlane/ngx-charts';
import { multi } from '../data';
import { Cookies } from 'typescript-cookie';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { Building, Business, Floor, TypeOfJob } from '@admin/models';
import {
  BuildingService,
  BusinessService,
  FloorService,
  WorkplaceTypeService,
} from '@admin/services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DashboardService } from '@admin/services/dashboard.service';
import { LogoService, ToastAlertService } from '@core/index';
import { ButtonComponent } from '@shared/components';
import html2canvas from 'html2canvas';
import * as jspdf from 'jspdf';

interface HeatData {
  heat: number;
  x: string; // Day
  y: string; // Time
}

interface SeriesData {
  name: string;
  value: number;
}

interface TransformedData {
  name: string;
  series: SeriesData[];
}
@Component({
  selector: 'app-heat-map',
  standalone: true,
  imports: [
    NgxChartsModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ButtonComponent,
  ],
  templateUrl: './heat-map.component.html',
  styleUrl: './heat-map.component.css',
})
export class HeatMapV2Component implements OnInit {
  //services
  private logoService = inject(LogoService);
  private businessServices = inject(BusinessService);
  private destroyRef = inject(DestroyRef);
  #DashboardService = inject(DashboardService);
  building = inject(BuildingService);
  workplacetype = inject(WorkplaceTypeService);
  private alertService = inject(ToastAlertService);
  floor = inject(FloorService);
  //data grafica
  multi: any[] = [];
  view: [number, number] = [510, 400];
  order: string[] = ['En espera', 'En curso', 'Eliminado', 'Culminado'];
  public valorRango = '';
  public selectValueCompani = -1;

  //generic
  cookieRole = Cookies.get('role');
  businessId: number = -1;
  buildingId: number = -1;
  floorId: number = -1;
  workPlaceId: number = -1;
  filter: string = 'lastMonth';
  private TypeWorkplace = signal(0);
  public transformedData: TransformedData[] = [];
  public bussinesForLogo: Business[] = [];

  //data
  public bussines: Business[] = [];
  edificios: Building[] = [];
  puestos: TypeOfJob[] = [];
  floors: Floor[] = [];
  rangeFilter = signal([
    { value: 'lastWeek', name: 'Última semana' },
    { value: 'lastMonth', name: 'Último mes' },
    { value: 'lastThreeMonths', name: 'Últimos 3 meses' },
    { value: 'lastYear', name: 'Último año' },
  ]);

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Día';
  showYAxisLabel = true;
  yAxisLabel = 'Horario';

  colorScheme: Color = {
    domain: [
      '#6ad180',
      '#90d865',
      '#badc48',
      '#d6c226',
      '#e2961d',
      '#d25c30',
      '#c24039',
    ],
    name: 'Grayscale',
    selectable: true,
    group: ScaleType.Ordinal,
  };
  onRangeChange(event: any) {
    const selectedValue = event.value;
    const selectedRange = this.rangeFilter().find(
      range => range.value === selectedValue
    );

    if (selectedRange && selectedRange.name) {
      this.valorRango = selectedRange.name;
    } else {
      this.valorRango = 'Último mes';
    }

    console.log('Valor seleccionado:', selectedValue);
    console.log('Nombre del rango seleccionado:', this.valorRango);

    this.getReservationsGraphic();
  }
  constructor() {
    Object.assign(this, { multi });
  }
  ngOnInit(): void {
    this.updateChartView(window.innerWidth);
    this.getBusiness();
    const business = Cookies.get('bussinesId')?.toString();

    if (business !== null) {
      this.ObtenerEdificios(parseInt(business!));
      this.ObtenerPuestos(parseInt(business!));
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateChartView(event.target.innerWidth);
  }

  updateChartView(width: number) {
    if (width < 600) {
      this.view = [230, 300]; // Vista para móviles
    } else if (width < 1200) {
      this.view = [400, 350]; // Vista para tabletas
    } else {
      this.view = [510, 400]; // Vista para escritorio
    }
  }
  private getBusiness() {
    this.businessServices
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000 || request.code === 40009) {
            this.bussines = request.reply;
            this.bussinesForLogo = request.reply;
          }
        },
      });
    this.edificios = [];
    this.puestos = [];
    this.floors = [];
    this.buildingId = -1;
    this.floorId = -1;
    this.workPlaceId = -1;
  }
  ObtenerEdificios(businessId: number) {
    this.loadLogo();
    this.edificios = [];
    this.puestos = [];
    this.floors = [];
    this.buildingId = -1;
    this.floorId = -1;
    this.workPlaceId = -1;
    this.businessId = businessId;
    console.log(this.businessId);
    this.getReservationsGraphic();
    this.building.getBuildings(businessId).subscribe(response => {
      if (response.status) {
        this.edificios = response.reply;
      } else {
        console.error('Error al obtener los los edificios:', response.detail);
      }
    });

    this.ObtenerPuestos(this.businessId);
  }
  ObtenerPuestos(businessId: number) {
    this.businessId = businessId;
    this.workplacetype.getWorkplaces(businessId).subscribe(response => {
      if (response.status) {
        this.puestos = response.reply;
      } else {
        this.alertService.error(response.detail);
      }
    });
  }
  selectType(type: number): void {
    this.TypeWorkplace.set(type);
    this.getReservationsGraphic();
  }
  selectFloor(floor: number): void {
    this.floorId = floor;
    console.log(this.floorId);
    this.getReservationsGraphic();
  }
  chargueFloorByBuilding(buldingid: number) {
    this.floors = [];
    this.floorId = -1;
    this.floor
      .getFloorsByBuilding(buldingid)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.floors = resp.reply || [];
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
    this.getReservationsGraphic();
  }

  inicio = '';
  fin = '';
  getReservationsGraphic() {
    this.inicio = '';
    this.fin = '';
    const business = Cookies.get('bussinesId')?.toString();

    let formData: any = {
      filter: this.filter,
      businessId: this.businessId !== -1 ? this.businessId : undefined,
      workPlaceId: this.workPlaceId !== -1 ? this.workPlaceId : undefined,
      buildingId: this.buildingId !== -1 ? this.buildingId : undefined,
      floorId: this.floorId !== -1 ? this.floorId : undefined,
    };
    console.log('formdata', formData);
    if (this.cookieRole !== 'SYSADMIN') {
      if (business !== null) {
        formData.businessId = business;
      }
    }
    if (
      !isNaN(this.businessId) &&
      this.businessId !== -1 &&
      this.businessId !== null
    ) {
      formData.businessId = this.businessId;
    } else {
      delete formData.businessId;
    }

    if (formData.workPlaceId === -1) {
      delete formData.workPlaceId;
    }
    if (formData.buildingId === -1) {
      delete formData.buildingId;
    }
    if (formData.floorId === -1) {
      delete formData.floorId;
    }
    console.log(formData);
    this.#DashboardService.getReservationsHeatMap(formData).subscribe({
      next: (request: any) => {
        if (request.code === 10000 || request.code === 40009) {
          const data: HeatData[] = request.reply.data;
          this.fin = request.reply.endDate;
          this.inicio = request.reply.startDate;
          console.log('data con inicio', this.inicio);
          console.log('data con final', this.fin);
          const allZeros = data.every(item => item.heat === 0);

          if (allZeros) {
            this.colorScheme.domain = [
              '#6ad180',
              '#6ad180',
              '#6ad180',
              '#6ad180',
              '#6ad180',
            ];
          } else {
            this.colorScheme.domain = [
              '#6ad180',
              '#90d865',
              '#badc48',
              '#d6c226',
              '#e2961d',
              '#d25c30',
              '#c24039',
            ];
          }
          this.updateChartData(this.transformData(data));
        }
      },
    });
  }
  updateChartData(newData: TransformedData[]) {
    this.multi = newData;
    console.log('Datos de la gráfica actualizados:', this.multi);
  }

  transformData(data: HeatData[]): TransformedData[] {
    // Diccionario para los días de la semana en inglés
    const dayMap: { [key: string]: string } = {
      Monday: 'Lunes',
      Tuesday: 'Martes',
      Wednesday: 'Miércoles',
      Thursday: 'Jueves',
      Friday: 'Viernes',
      Saturday: 'Sábado',
      Sunday: 'Domingo',
    };

    // Mapa para acumular los datos transformados
    const transformedDataMap: { [key: string]: TransformedData } = {};

    // Procesar y agrupar los datos por día de la semana
    data.forEach(item => {
      const dayName = dayMap[item.x] || item.x; // Traducir el día al español
      const hour = item.y.split(':')[0]; // Obtener la hora sin minutos

      if (!transformedDataMap[dayName]) {
        transformedDataMap[dayName] = {
          name: dayName,
          series: [],
        };
      }

      transformedDataMap[dayName].series.push({
        name: hour,
        value: item.heat,
      });
    });

    // Transformar el mapa en una lista y ordenar por día y hora
    const orderedDays = [
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
      'Domingo',
    ];
    const transformedData = Object.keys(transformedDataMap).map(
      day => transformedDataMap[day]
    );

    // Ordenar los días y las horas dentro de cada día
    transformedData.sort(
      (a, b) => orderedDays.indexOf(a.name) - orderedDays.indexOf(b.name)
    );
    transformedData.forEach(dayData => {
      dayData.series.sort((a, b) => parseInt(a.name) - parseInt(b.name));
    });

    return transformedData;
  }
  onSelect(event: any) {
    console.log(event);
  }

  downloadExcel(): void {
    const business = Cookies.get('bussinesId')?.toString();

    let formData: any = {
      filter: this.filter,
      businessId: this.businessId !== -1 ? this.businessId : undefined,
      workPlaceId: this.workPlaceId !== -1 ? this.workPlaceId : undefined,
      buildingId: this.buildingId !== -1 ? this.buildingId : undefined,
      floorId: this.floorId !== -1 ? this.floorId : undefined,
    };
    if (this.cookieRole !== 'SYSADMIN') {
      if (business !== null) {
        formData.businessId = business;
      }
    }
    if (
      !isNaN(this.businessId) &&
      this.businessId !== -1 &&
      this.businessId !== null
    ) {
      formData.businessId = this.businessId;
    } else {
      delete formData.businessId;
    }

    if (formData.workPlaceId === -1) {
      delete formData.workPlaceId;
    }
    if (formData.buildingId === -1) {
      delete formData.buildingId;
    }
    if (formData.floorId === -1) {
      delete formData.floorId;
    }
    console.log(formData);
    this.#DashboardService
      .getReservationsHeatMapCSV(formData)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: Blob) => {
        console.log('data', data);
        if (data.type == 'application/json') {
          this.alertService.warning('No hay datos para descargar.');
        } else {
          const file = new Blob([data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'reporte_horarios_mas_ocupados.xlsx';
          link.click();
          window.URL.revokeObjectURL(url);
        }
      });
  }

  imgsysadmin = '';
  idlogoSeleccionado: number = -1;
  loadLogo() {
    this.imgsysadmin = '';
    this.idlogoSeleccionado = -1;
    if (this.cookieRole === 'SYSADMIN') {
      for (const business of this.bussinesForLogo) {
        if (business.idBusiness === this.selectValueCompani) {
          this.idlogoSeleccionado = business.idLogo || 0;
        }
      }
    } else if (this.cookieRole === 'ADMINISTRADOR') {
      const logo = Cookies.get('logo');
      this.idlogoSeleccionado = logo ? Number(logo) : 0;
    }

    // Obtener el logo correspondiente
    if (this.idlogoSeleccionado > 0) {
      this.logoService.getOneLogo(this.idlogoSeleccionado).subscribe({
        next: ({ reply }) => {
          this.imgsysadmin = reply.value;
          console.log('imagen en base 64', this.imgsysadmin);
        },
      });
    } else {
      const imgElement = new Image();
      imgElement.onload = () => {
        // Convertir la imagen alternativa a base64 cuando se genere el PDF
        this.imgsysadmin = imgElement.src;
        console.log('imagen alternativa cargada', this.imgsysadmin);
      };
      imgElement.src = '../../../../../assets/icon.png';
    }
  }

  tableData: any[] = [];
  hours = Array.from(
    { length: 24 },
    (_, i) => i.toString().padStart(2, '0') + ':00'
  );
  download() {
    function modifySaturation(
      base64Image: string,
      saturation: number
    ): Promise<string> {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = base64Image;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
          canvas.width = img.width;
          canvas.height = img.height;

          // Dibuja la imagen en el canvas temporal
          ctx.drawImage(img, 0, 0);

          // Aplica el filtro de saturación
          ctx.filter = `saturate(${saturation})`;
          ctx.drawImage(canvas, 0, 0);

          // Obtén la nueva imagen en formato base64
          const modifiedBase64Image = canvas.toDataURL();
          resolve(modifiedBase64Image);
        };

        img.onerror = error => {
          reject(error);
        };
      });
    }
    const canvasElement = document.getElementById(
      'reservations'
    ) as HTMLCanvasElement;

    // Capturar el contenido del canvas como una imagen
    html2canvas(canvasElement).then(reservationCanvas => {
      const reservationImgData = reservationCanvas.toDataURL('image/png');
      //const ImgNew = enhanceBlacks(reservationImgData, 5, 3);

      modifySaturation(reservationImgData, 10).then(modifiedBase64Image => {
        console.log(modifiedBase64Image);

        // Configurar el documento PDF
        const pdf = new jspdf.jsPDF('p', 'mm', 'letter');

        // Definir márgenes y dimensiones de página
        const leftMargin = 25; // Margen izquierdo en mm
        const rightMargin = 25; // Margen derecho en mm
        const pageWidth = pdf.internal.pageSize.getWidth(); // Ancho de la página en mm
        const usableWidth = pageWidth - leftMargin - rightMargin;

        let logoWidth = 15; // Ancho del logo en mm
        let logoHeight = 15; // Alto del logo en mm

        // Verificar si es la imagen alternativa
        const isAlternativeImage = this.imgsysadmin.includes('assets/icon.png');
        console.log('isAlternativeImage:', isAlternativeImage);

        if (isAlternativeImage) {
          logoWidth = 30; // Ancho del logo alternativo en mm
          logoHeight = 15; // Alto del logo alternativo en mm
        }

        // Agregar logo al PDF si está disponible
        if (this.imgsysadmin) {
          const logoX = leftMargin; // Posición X del logo (a la izquierda)
          const logoY = 5; //*MOVER LOGO EN Y

          pdf.addImage(
            this.imgsysadmin,
            'PNG',
            logoX,
            logoY,
            logoWidth,
            logoHeight
          );
        }

        // Agregar título del reporte
        const titleText = 'Horarios más ocupados';
        const titleFontSize = 18; // Tamaño de fuente del título
        const titleTextWidth =
          (pdf.getStringUnitWidth(titleText) * titleFontSize) /
          pdf.internal.scaleFactor;
        const titleX = (pageWidth - titleTextWidth) / 2; // Centrado horizontalmente
        let titleY = 40; // Posición Y del título

        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(titleFontSize);
        pdf.text(`Horarios más ocupados`, titleX, titleY - 25); //*MOVER TITULO X Y Y

        const middleX = pageWidth / 2;
        const staticText = `De: ${this.inicio}         Al: ${this.fin}`;
        const staticTextFontSize = 12;
        const staticTextWidth =
          (pdf.getStringUnitWidth(staticText) * staticTextFontSize) /
          pdf.internal.scaleFactor;
        const staticTextX = (pageWidth - staticTextWidth) / 2; // Centrado horizontalmente
        const staticTextY = titleY - 18; //*pocicon en y

        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(staticTextFontSize);
        pdf.text(staticText, staticTextX + 8, staticTextY); //*margen en x

        //*Tabla
        const headers = [
          'Hora',
          'Lunes',
          'martes',
          'Miércoles',
          'Jueves',
          'Viernes',
          'Sábado',
          'Domingo',
        ];

        const tableData = this.hours.map(hour => {
          const row = [hour];

          this.multi.forEach(day => {
            const hourData = day.series.find(
              (h: { name: string }) => h.name === hour.split(':')[0]
            );
            if (hourData) {
              row.push(hourData.value.toString());
            } else {
              row.push('0');
            }
          });

          return row;
        });

        const tableX = middleX - 65 + 20; //*MOVER EN X
        const tableY = titleY + 75;
        const lineHeight = 5.0; //*ESPACIO ENTRE TABLAS
        const startY = tableY;

        // Definir anchos de columnas
        const columnWidth = ((usableWidth - leftMargin) / headers.length) * 0.9;

        // Dibujar encabezados
        pdf.setFillColor(255, 255, 255);
        pdf.setDrawColor(0, 0, 0);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(7.5);
        pdf.setTextColor(0, 0, 0);
        pdf.rect(
          tableX - 17,
          startY - 1,
          usableWidth - middleX + 55 + 17,
          lineHeight,
          'FD'
        ); //* +65 lineas de encabezado de la tabal estilo
        let currentX = tableX - 18; //*MOVER ENCABEZADO DE DIAS A LA IZQ
        let currentY = startY + lineHeight / 2;
        headers.forEach(header => {
          const width = pdf.getStringUnitWidth(header) * 1;
          pdf.text(header, currentX + (columnWidth - width) / 2, currentY);
          currentX += columnWidth;
        });

        // Dibujar datos
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(10);
        currentY += lineHeight / 2;
        tableData.forEach((dataRow, index) => {
          currentX = tableX - 10; //*MOVER COLUMNA DE HORA A LA IZQ
          currentY += lineHeight;
          pdf.rect(
            tableX - 17,
            currentY - 1,
            usableWidth - middleX + 55 + 17,
            lineHeight,
            'D'
          ); //*LARGO DE LINEAS DE TABLA
          dataRow.forEach((cell, cellIndex) => {
            const width = pdf.getStringUnitWidth(cell.toString()) * 10;
            pdf.text(
              cell.toString(),
              currentX + (columnWidth - width) / 2,
              currentY + lineHeight / 2
            );
            currentX += columnWidth;
          });
        });

        //* Agregar gráfico y datos
        const graphX = leftMargin; //*MOVER GRAFICA EN X
        const graphY = titleY - 15; //*MOVER GRAFICA EN Y
        const contentHeight = reservationCanvas.height;
        const contentWidth = reservationCanvas.width;
        const halfWidth = usableWidth / 2;
        const halfHeight = (halfWidth * contentHeight) / contentWidth;

        pdf.addImage(
          modifiedBase64Image,
          'PNG',
          graphX,
          graphY,
          halfWidth + 50 + 20,
          halfHeight + 20
        );
        // Agregar total

        pdf.setFontSize(12);
        const currentDate = new Date();
        const formattedDate = `${currentDate.toLocaleDateString()} ${currentDate.toLocaleTimeString()}`;
        const footerY = pdf.internal.pageSize.height - 10;
        const user = Cookies.get('username');

        pdf.setTextColor(0, 0, 255);
        pdf.setFont('helvetica');
        pdf.setFontSize(10);
        pdf.text(
          formattedDate,
          pageWidth - rightMargin - pdf.getTextWidth(formattedDate),
          footerY
        );
        pdf.text(
          `Usuario: ${user}`,
          pageWidth - rightMargin - pdf.getTextWidth(`Usuario: ${user}`),
          footerY + 5
        );

        pdf.save('Horarios más ocupados.pdf');
      });
    });
  }
}
